export default "__VITE_ASSET__BaXIKnkG__"